import ApiService from '../api.service';

const BudgetSolicitationResource = {
  create: (params) => ApiService.post('/v1/budget_request', params),
};

export default BudgetSolicitationResource;
